<template>
  <div class="page">
    <el-card class="card-basic">
      <el-row>
        <el-col>
          <el-form class="card-form" :inline="true" :model="formInline">
            <el-form-item label="预警人">
              <el-input clearable v-model="formInline.name" placeholder="预警人"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="drawer=true">添加预警</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="card-basic">
      <el-row>
        <el-col>
          <el-table border :data="filterTableData">
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column prop="projectName" label="工程名称/ID" align="center">
              <template slot-scope="scope">
                {{scope.row.alarmProjectName}} / {{scope.row.alarmProjectId}}
              </template>
            </el-table-column>
            <el-table-column prop="stationName" label="测站名称/ID" align="center">
              <template slot-scope="scope">
                {{scope.row.alarmStationName}} / {{scope.row.alarmStationId}}
              </template>
            </el-table-column>
            <el-table-column prop="alarmUserName" label="预警人" align="center"></el-table-column>
            <el-table-column prop="alarmUserPhone" label="手机" align="center"></el-table-column>
            <el-table-column prop="alarmUserEmail" label="邮箱" align="center"></el-table-column>
            <el-table-column prop="alarmType" label="预警功能" align="center">
              <template slot-scope="scope">
                <!-- <el-tag>{{scope.row.alarmType==='1'?'数值预警':'状态预警'}}</el-tag> -->
                <el-tag v-for="(t,index) in scope.row.alarmType" :key="'alarm-type-'+index">{{t==='1'?'数值预警':'状态预警'}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="alarmSendType" label="预警类型" align="center">
              <template slot-scope="scope">
                <el-tag v-for="(t,index) in scope.row.alarmSendType" :key="'send-type-'+index">{{t==='1'?'邮件':'短信'}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="160" align="center">
              <template slot-scope="scope">
                <el-button @click="editUser(scope.row,scope.$index)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteUser(scope.row,scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
    <el-drawer :title="this.drawerModel === 'update'?'编辑预警':'添加预警'" :visible.sync="drawer" :direction="direction"
      class="demo-drawer" size="40%">
      <el-form :inline="false" label-width="120px" label-position="right" ref="addAlarmFormInline"
        :model="addFormInline" :rules="rules" class="demo-ruleForm" size="mini">
        <el-form-item label="工程" prop="alarmProjectId">
          <el-select style="width:100%" v-model="addFormInline.alarmProjectId" @change="loadStationList">
            <el-option v-for="(p,index) in projectList" :key="'project-'+index" :label="p.projectName"
              :value="p.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="测站" prop="alarmStationId">
          <el-select style="width:100%" v-model="addFormInline.alarmStationId" value-key="projectStationId">
            <el-option v-for="(s,index) in stationList" :key="'station-'+index" :value="s.projectStationId"
              :label="s.projectStationName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预警功能" prop="alarmType">
          <el-checkbox-group v-model="addFormInline.alarmType">
            <el-checkbox label="1">数值预警</el-checkbox>
            <el-checkbox label="2">状态预警</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="预警人" prop="alarmUserName">
          <el-input v-model="addFormInline.alarmUserName" placeholder="预警人"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="alarmUserPhone">
          <el-input v-model="addFormInline.alarmUserPhone" placeholder="手机"></el-input>
        </el-form-item>
        <el-form-item label="EMAIL" prop="alarmUserEmail">
          <el-input v-model="addFormInline.alarmUserEmail" placeholder="EMAIL"></el-input>
        </el-form-item>
        <el-form-item label="预警类型" prop="alarmSendType">
          <el-checkbox-group v-model="addFormInline.alarmSendType">
            <el-checkbox label="1">邮件</el-checkbox>
            <el-checkbox label="2">短信</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addUser">保存</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
import { listProjectAlarmPromise, addProjectAlarmPromise, updateProjectAlarmPromise, deleteProjectAlarmPromise } from "@/api/alarmApi";
import {
  listStation
} from "@/api/stationApi";
import { listProject } from "@/api/projectApi";
export default {
  data() {
    return {
      drawer: false,
      drawerModel: "",
      direction: "rtl",
      formInline: {},
      rules: {
        alarmProjectId: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
        alarmStationId: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
        alarmType: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
        alarmUserName: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
        alarmUserPhone: [
          { required: true, message: "该项为必填项", trigger: "blur" },
          { validator: this.validatePhoneNo, trigger: "blur" }
        ],
        alarmUserEmail: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
        alarmSendType: [
          { required: true, message: "该项为必填项", trigger: "blur" }
        ],
      },
      projectList: [],
      stationList: [],
      addFormInline: {
        alarmSendType: [],
        alarmType: [],
      },
      alarmList: []
    };
  },
  mounted() {
    this.loadProjectList();
    this.loadAlarmList();
  },
  methods: {
    loadAlarmList() {
      listProjectAlarmPromise({})
        .then(res => {
          const resp = res.data;
          console.log(resp);
          if (resp.code === 200) {
            this.alarmList = resp.content.map(res => {
              res.alarmSendType = JSON.parse(res.alarmSendType);
              res.alarmType = JSON.parse(res.alarmType);
              return res;
            });
          } else {
            this.$message.error("数据加载失败:" + resp.msg);
          }
        }).catch(() => {
          this.$message.error("数据加载失败");
        });
    },
    loadProjectList() {
      listProject({}).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.projectList = resp.content;
        } else {
          this.$message.warning("未加载到工程数据");
        }
      });
    },
    loadStationList() {
      if (!this.addFormInline.alarmProjectId) {
        return;
      }
      this.stationList = [];
      this.$set(this.addFormInline, "alarmStationId", "");
      listStation({ projectId: this.addFormInline.alarmProjectId }).then(res => {
        const resp = res.data;
        if (resp.code === 200) {
          this.stationList = resp.content;
        } else {
          this.$message.warning("未加载到测站数据");
        }
      });
    },
    editUser(row, index) {
      const updateData = JSON.parse(JSON.stringify(row));
      this.addFormInline = updateData;
      this.drawer = true;
      this.drawerModel = "update";
    },
    deleteUser(row) {
      this.$confirm("确认删除？")
        .then(_ => {
          const addData = JSON.parse(JSON.stringify(row));
          addData.alarmSendType = JSON.stringify(this.addFormInline.alarmSendType);
          addData.alarmType = JSON.stringify(this.addFormInline.alarmType);
          deleteProjectAlarmPromise(addData).then(res => {
            const resp = res.data;
            if (resp.code === 200) {
              this.loadAlarmList();
              this.$message.success("删除成功");
            } else {
              this.$message.error("删除失败:" + resp.msg);
            }
          }).catch(() => {
            this.$message.error("删除失败");
          });
        })
        .catch(_ => { });
    },
    addUser() {
      this.$refs.addAlarmFormInline.validate(valid => {
        if (valid) {
          if (this.drawerModel === "update") {
            const addData = JSON.parse(JSON.stringify(this.addFormInline));
            addData.alarmSendType = JSON.stringify(this.addFormInline.alarmSendType);
            addData.alarmType = JSON.stringify(this.addFormInline.alarmType);
            updateProjectAlarmPromise(addData).then(res => {
              const resp = res.data;
              if (resp.code === 200) {
                this.loadAlarmList();
                this.$message.success("修改成功");
              } else {
                this.$message.error("修改失败:" + resp.msg);
              }
            }).catch(() => {
              this.$message.error("修改失败");
            });
            this.drawerModel = "";
          } else {
            const addData = JSON.parse(JSON.stringify(this.addFormInline));
            addData.alarmSendType = JSON.stringify(this.addFormInline.alarmSendType);
            addData.alarmType = JSON.stringify(this.addFormInline.alarmType);
            addProjectAlarmPromise(addData).then(res => {
              const resp = res.data;
              if (resp.code === 200) {
                this.loadAlarmList();
                this.$message.success("添加成功");
              } else {
                this.$message.error("添加失败:" + resp.msg);
              }
            }).catch(() => {
              this.$message.error("添加失败");
            });
            this.drawerModel = "";
          }
          this.drawer = false;
        }
      });
    },
    validatePhoneNo(rule, value, callback) {
      if (!/^([0-9]{11})$/.test(value)) {
        callback(new Error("只能输入0-9之间的数字,且长度只能为11位,当前已输入" + value.length + "位"));
      } else {
        callback();
      }
    }
  },
  computed: {
    filterTableData() {
      let data = this.alarmList;
      if (this.formInline.name) {
        data = data.filter(v =>
          v.alarmUserName.toLowerCase().includes(this.formInline.name)
        );
      }
      return data;
    }
  }
};
</script>
<style scoped>
.card-basic {
  margin: 5px 10px;
}
.card-form .el-form-item {
  margin-bottom: 0px;
}
.demo-ruleForm {
  width: calc(100% - 10px);
}
</style>
